// @ts-nocheck
import React, { SyntheticEvent, useState } from 'react';
import styled from 'styled-components';
import { message } from 'antd';
import checkApiStatus from '../api/check-api-status';
import { createFile, appendFile, flushFile } from '../api/upload-services';
import createArrayBuffer from '../utils/create-array-buffer';
import calculatePercentage from '../utils/calculate-percentage';
import UploadButton from './upload-button';

const Wrapper = styled.div`
  display: flex;
`;

export interface IUploadComponentProps {
  uploadType: string;
  allowedFileTypes?: Array<string>;
  onFinish?: (param: any) => void;
  loading?: boolean;
}

const UploadComponent = ({
  uploadType,
  allowedFileTypes = [],
  onFinish,
  loading,
}: IUploadComponentProps) => {
  const [uploadPercentage, setUploadPercentage] = useState(0);
  const [isUploading, setIsUploading] = useState(false);

  const processFileAppend = async (
    uniqueIdentifier: string,
    file: File,
    uploadType: string
  ) => {
    // Constant value that defines the chunk amount
    const BYTES_PER_CHUNK = 1048576 * 1; // 1MB
    console.log('Bytes per chunk: ', BYTES_PER_CHUNK);

    // Total chunks of data
    const totalChunks = Math.max(Math.ceil(file.size / BYTES_PER_CHUNK), 1);
    console.log(`Sending ${totalChunks} chunks`);

    let bytePosition = 0;

    // Resume upload from previous byteposition
    for (
      bytePosition;
      bytePosition < file.size;
      bytePosition += BYTES_PER_CHUNK
    ) {
      console.log(`Sending ${bytePosition}/${file.size}`);
      // Take the correct data chunk
      const chunkBlob = file.slice(
        bytePosition,
        bytePosition + BYTES_PER_CHUNK
      );
      // Convert it to an array buffer
      const arrayBufferFile = await createArrayBuffer(chunkBlob);
      // Call append service
      await appendFile(
        uniqueIdentifier,
        bytePosition,
        arrayBufferFile,
        uploadType
      );
      // Set progressbar
      const percentageComplete = calculatePercentage(bytePosition, file.size);
      setUploadPercentage(percentageComplete);
    }
    setUploadPercentage(100);
  };

  const checkAllowedFileTypes = (
    allowedFileTypes: Array<string>,
    fileName: string
  ) => {
    const typeIsAllowed = !!allowedFileTypes.filter((fileType) => {
      return fileName.endsWith(fileType);
    }).length;

    if (!typeIsAllowed) {
      // eslint-disable-next-line no-throw-literal
      throw {
        customMessage: `This filetype is not allowed, allowed filetypes are: ${allowedFileTypes.join(
          ','
        )}`,
      };
    }
  };

  const uploadFile = async (event: SyntheticEvent) => {
    try {
      setIsUploading(true);
      setUploadPercentage(0);
      const file = event.target.files[0];

      checkAllowedFileTypes(allowedFileTypes, file.name);

      // Create file
      const uniqueIdentifier = await createFile(uploadType);
      // Process file append
      await processFileAppend(uniqueIdentifier, file, uploadType);
      // Flush file
      await flushFile(uniqueIdentifier, file.size, uploadType);
      // Optional: Do extra onFinish action
      if (onFinish) {
        onFinish(uniqueIdentifier);
      }
      setIsUploading(false);
    } catch (err) {
      setIsUploading(false);
      const errorMessage = checkApiStatus(err);
      message.error(errorMessage);
    }
  };

  return (
    <Wrapper>
      <UploadButton
        uploadFile={uploadFile}
        isUploading={isUploading || loading}
        uploadPercentage={uploadPercentage}
      />
    </Wrapper>
  );
};

export default UploadComponent;
